export enum ChatReceiver {
	All,
	Group,
	User,
}

export enum ChatUpdateType {
	Init,
	Change,
}

export type ChatUpdateInit = {
	type: ChatUpdateType.Init
	all: ChatMessage[]
	private?: Record<string, ChatMessage[]>
	group?: Record<string, ChatMessage[]>
}

export type ChatUpdateChange = {
	type: ChatUpdateType.Change
	chatMessage: ChatMessage
}

export type ChatMessage = {
	id?: string
	authorId?: string
	message: string
	receiverId?: string
	receiverType: ChatReceiver
	timestamp?: number
}

export type ChatUpdate = ChatUpdateInit | ChatUpdateChange
